import { T as TailwindStyledElement, x } from '../../index-e3189942.js';
import { e, a as e$1 } from '../../directive-9ec64c08.js';
import { o } from '../../style-map-e2dd0466.js';
import { c as customClassMap } from '../../index-714323c9.js';
import '../lukso-profile/index.js';

const style = ":host {\n  display: flex;\n  width: 100%;\n}\n\n:host([is-fixed-width]) {\n  width: inherit;\n}";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let LuksoCard = class extends TailwindStyledElement(style) {
  constructor() {
    super(...arguments);
    this.variant = "basic";
    this.backgroundUrl = "";
    this.profileUrl = "";
    this.profileAddress = "";
    this.isFixedWidth = false;
    this.isFixedHeight = false;
    this.isFullWidth = false;
    this.customClass = "";
    this.defaultStyles = `rounded-24 shadow-neutral-drop-shadow-2xl`;
  }
  basicTemplate() {
    return x`
      <div
        data-testid="card"
        class="bg-neutral-100 ${customClassMap({
      [this.defaultStyles]: !this.customClass,
      [this.customClass]: !!this.customClass,
      ["w-[362px]"]: this.isFixedWidth,
      ["min-h-[534px]"]: this.isFixedHeight,
      ["w-full"]: this.isFullWidth
    })}"
      >
        <slot name="content"></slot>
      </div>
    `;
  }
  withHeaderTemplate() {
    return x`
      <div
        data-testid="card"
        class="bg-neutral-98 grid grid-rows-[auto,1fr] ${customClassMap({
      [this.defaultStyles]: !this.customClass,
      [this.customClass]: !!this.customClass,
      ["w-[362px]"]: this.isFixedWidth,
      ["min-h-[534px]"]: this.isFixedHeight,
      ["w-full"]: this.isFullWidth
    })}"
      >
        <div>
          <slot name="header"></slot>
        </div>
        <div class="bg-neutral-100 shadow-neutral-above-shadow-1xl rounded-24">
          <slot name="content"></slot>
        </div>
      </div>
    `;
  }
  profileTemplate() {
    return x`
      <div
        data-testid="card"
        class="bg-neutral-98 grid grid-rows-[auto,1fr] ${customClassMap({
      [this.defaultStyles]: !this.customClass,
      [this.customClass]: !!this.customClass,
      ["w-[362px]"]: this.isFixedWidth,
      ["min-h-[534px]"]: this.isFixedHeight,
      ["w-full"]: this.isFullWidth
    })}"
      >
        <div
          style=${o({
      backgroundImage: `url(${this.backgroundUrl})`
    })}
          class="min-h-[129px] -mb-6 bg-center bg-cover rounded-[24px_24px_0_0] relative"
        >
          <div
            class="min-h-full min-w-full rounded-[24px_24px_0_0] bg-neutral-10 absolute opacity-10"
          ></div>
          <div>
            <slot name="header"></slot>
          </div>
        </div>
        <div
          class="bg-neutral-100 shadow-neutral-above-shadow-1xl rounded-24 relative"
        >
          <lukso-profile
            profile-url=${this.profileUrl}
            size="large"
            profile-address=${this.profileAddress}
            has-identicon
            class="absolute -top-[40px] left-[calc(50%_-_40px)] z-10"
          ></lukso-profile>
          <div
            class="overflow-hidden w-[153px] h-[70px] -top-[70px] relative mx-auto flex items-end justify-center -mb-2"
          >
            <div
              class="bg-neutral-100 rounded-[103px_103px_0_0] w-[96px] h-[48px]
              shadow-neutral-above-shadow-1xl"
            ></div>
          </div>
          <slot name="content"></slot>
        </div>
      </div>
    `;
  }
  render() {
    switch (this.variant) {
      case "with-header":
        return this.withHeaderTemplate();
      case "profile":
        return this.profileTemplate();
      default:
        return this.basicTemplate();
    }
  }
};
__decorateClass([
  e({ type: String })
], LuksoCard.prototype, "variant", 2);
__decorateClass([
  e({ type: String, attribute: "background-url" })
], LuksoCard.prototype, "backgroundUrl", 2);
__decorateClass([
  e({ type: String, attribute: "profile-url" })
], LuksoCard.prototype, "profileUrl", 2);
__decorateClass([
  e({ type: String, attribute: "profile-address" })
], LuksoCard.prototype, "profileAddress", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-fixed-width" })
], LuksoCard.prototype, "isFixedWidth", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-fixed-height" })
], LuksoCard.prototype, "isFixedHeight", 2);
__decorateClass([
  e({ type: Boolean, attribute: "is-full-width" })
], LuksoCard.prototype, "isFullWidth", 2);
__decorateClass([
  e({ type: String, attribute: "custom-class" })
], LuksoCard.prototype, "customClass", 2);
LuksoCard = __decorateClass([
  e$1("lukso-card")
], LuksoCard);

export { LuksoCard };
